if (typeof wwdev == 'undefined') {
	wwdev = {};
}

wwdev.Maps = {
	startLat: 52.3702157,
	startLng: 4.895167899999933,
	mapOptions : {},
	map : null,
	markers : {},
	bounds : {},

	setupStyles : function() {
		this.mapOptions['styles'] =
			[
				{
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#444444"
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "all",
					"stylers": [
						{
							"color": "#f2f2f2"
						}
					]
				},
				{
					"featureType": "landscape.natural.landcover",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "landscape.natural.terrain",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#b6b6b6"
						},
						{
							"visibility": "on"
						},
						{
							"weight": "5.64"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#c6c6c6"
						},
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#000000"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "all",
					"stylers": [
						{
							"saturation": -100
						},
						{
							"lightness": 45
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "all",
					"stylers": [
						{
							"color": "#46bcec"
						},
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#c4dbe9"
						}
					]
				}
			];
	},
	init : function () {
		$('.show-maps').click(function(e){
			e.preventDefault();
			$(this).closest('.gmaps-placeholder').slideUp();
			$(this).closest('.gmaps-placeholder').next().slideDown(400, function(){
				wwdev.Maps.initMaps();
			});
			// wwdev.Maps.initMaps();
			return false;
		});
	},
	initMaps : function () {
		//this.setupStyles();
		if (jQuery('div.google-maps:visible').length >= 1) {

			this.mapOptions.center = new google.maps.LatLng(this.startLat, this.startLng);
			this.mapOptions.zoom = 8;
			//this.mapOptions.mymaxZoom = 8;
			this.mapOptions.scrollwheel = false;
			var randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
			var uniqid = randLetter + Date.now();

			mapWrapper = jQuery('div.google-maps');
			var mapElement = jQuery('div.google-maps').find('.map');
			mapElement.attr('id', uniqid);
			var h = mapWrapper.data('minheight');
			if (!h) h =  750;
			mapElement.height(h);
			this.map = new google.maps.Map(document.getElementById(uniqid), this.mapOptions );

			this.bounds = new google.maps.LatLngBounds();
			var self = this;
			google.maps.event.addListener(this.map, 'tilesloaded', function() {
				jQuery('div.google-maps-loading').hide(500);
				mapWrapper.css({height : h, 'overflow': 'hidden'});
			});
			var markerCounter = mapWrapper.find('div.marker').length;
			mapWrapper.find('div.marker').each(function(){
				marker = jQuery(this).data();
				self.markers[marker.id] = new google.maps.Marker({
					position: new google.maps.LatLng(marker.lat, marker.lon),
					map: self.map,
					// icon: '/img/map-marker.png',
					maxWidth: 250,
					title: marker.title,
					html: '<div class="marker_wrapper">' + jQuery(this).html() + '</div>'
				});

				if( markerCounter > 1 ) {
					self.bounds.extend(self.markers[marker.id].position);
				} else {
					self.map.setCenter(self.markers[marker.id].position)
				}

				google.maps.event.addListener(self.markers[marker.id], 'click', jQuery.proxy(self.showInfoWindow, self, self.markers[marker.id]));

			});
			google.maps.event.addListener(this.map, 'bounds_changed', jQuery.proxy(function(event) {
				//this.map.setZoom( Math.min( 8, this.map.getZoom() ) );
			}, this));
			if( markerCounter > 1 ) {
				this.map.fitBounds(this.bounds);
			}
		}
	},
	showInfoWindow :function (marker, arg2) {
		this.closeAllInfoWindows();
		if ( typeof(marker.infoWindow) == 'undefined' ) {
			marker.infoWindow = new google.maps.InfoWindow({
				content: marker.html
			});
			google.maps.event.addListener(marker.infoWindow, 'domready',this.infoWindowOpened)

		}
		marker.infoWindow.open( this.map, marker );
	},
	infoWindowOpened : function() {
		// Reference to the DIV that wraps the bottom of infowindow
		var iwOuter = $('.gm-style-iw');

		/* Since this div is in a position prior to .gm-div style-iw.
		 * We use jQuery and create a iwBackground variable,
		 * and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
		*/
		var iwBackground = iwOuter.prev();

		// Removes background shadow DIV
		iwBackground.children(':nth-child(2)').css({'display' : 'none'});

		// Removes white background DIV
		iwBackground.children(':nth-child(4)').css({'display' : 'none'});

		// Moves the infowindow 115px to the right.
		iwOuter.parent().parent().css({left: '63px'});

		// Moves the shadow of the arrow 76px to the left margin.
		iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});

		// Moves the arrow 76px to the left margin.
		iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});

		// Changes the desired tail shadow color.
		iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

		// Reference to the div that groups the close button elements.
		var iwCloseBtn = iwOuter.next();

		// Apply the desired effect to the close button
		iwCloseBtn.css({opacity: '1', right: '38px', top: '3px', width: '25px', height: '25px', border: '6px solid white', borderRadius: '50%'});

		// If the content of infowindow not exceed the set maximum height, then the gradient is removed.
		if($('.iw-content').height() < 140){
			$('.iw-bottom-gradient').css({display: 'none'});
		}

		// The API automatically applies 0.7 opacity to the button after the mouseout event. This function reverses this event to the desired value.
		iwCloseBtn.mouseout(function(){
			$(this).css({opacity: '1'});
		});

	},
	closeAllInfoWindows : function() {
		jQuery.each(this.markers, function(it, marker) {
			if( typeof( marker.infoWindow ) != 'undefined') {
				marker.infoWindow.close();
			}
		});
	}
};

$(document).ready(() => {
	wwdev.Maps.initMaps();
});